import React from 'react';
import BackgroundBeams from '../background-beams';

const InfoSection = ({ activeTab = "student" }) => {
    const content = {
        student: {
          title: "Unlock Your Learning Potential: Find the Perfect Home Tutor",
          text: "Ace CBSE, ICSE & beyond with personalized home tuition! Expert tutors for every grade, every subject.",
          cards: [
            {
              title: "Personalized Learning, Maximum Impact",
              description: "Say goodbye to generic lessons! Your tutor will craft a learning plan tailored specifically to YOU and your needs, ensuring you grasp concepts faster and achieve your goals.",
            },
            {
              title: "Undivided Attention, Zero Distractions",
              description: "Enjoy the power of one-on-one learning! Get 100% focused attention, ask unlimited questions, and conquer even the toughest topics with confidence.",
            },
            {
              title: "Transform Grades, Transform Your Future",
              description: "Elevate your grades and unlock your academic potential! Our expert tutors provide the guidance and support you need to excel in your studies and achieve your dreams.",
            },
          ],
        },
        tutor: {
          title: "Shape the Future: Empower Students as a Home Tutor",
          text: "Inspire young minds, set your own schedule, and earn competitive rates. Become a valued tutor and make a difference!",
          cards: [
            {
              title: "Be Your Own Boss: Teach on Your Terms",
              description: "Enjoy the freedom and flexibility of setting your own schedule and choosing the students you want to work with. We connect you with enthusiastic learners ready to achieve their academic goals.",
            },
            {
              title: "Flexible Hours, Rewarding Income",
              description: "Balance your life and your career with flexible tutoring hours. Earn competitive rates and get rewarded for your expertise and dedication to student success.",
            },
            {
              title: "Part-Time Gig, Full-Time Impact",
              description: "Make a meaningful difference in the lives of students while earning extra income. Parents are actively seeking dedicated tutors like you to help their children thrive.",
            },
          ],
        },
      };

  // Default to 'student' if activeTab is not valid
  const currentContent = content[activeTab] || content.student;

  return (
    <section className="bg-white text-black grid place-content-center py-24 sticky top-0 rounded-tr-3xl rounded-tl-3xl overflow-hidden px-6">
      <BackgroundBeams />
      <div className="z-10 mt-8 md:mt-2 mx-4">
        <h1 className="2xl:text-7xl text-4xl px-8 font-semibold text-center tracking-tight leading-[120%]">
          {currentContent.title}
        </h1>
        <p className="text-xl text-center mt-6 max-w-2xl mx-auto">{currentContent.text}</p>

        {/* Cards Section */}
        <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {currentContent.cards.map((card, index) => (
            <div
              key={index}
              className=" bg-gradient-to-br from-pink-50 to-sky-100 rounded-xl p-6 shadow-lg hover:shadow-xl transform hover:-translate-y-2 transition-all duration-300 border border-gray-300"
            >
              <h3 className="text-2xl font-bold text-gray-800 mb-3">{card.title}</h3>
              <p className="text-gray-600 text-base">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InfoSection;